module.exports = __webpack_public_path__ + "static/media/subscriptions.97afcff7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/subscriptions.svg
// module id = ./src/assets/media/forum/subscriptions.svg
// module chunks = 16